import React from 'react';

import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';

import {
  ChevronIcon,
  Heading,
  LearningIcon,
  Text,
  TickIcon,
} from '@edume/magnificent';

import styles from './styles.module.scss';

function TeamPerformanceCard({
  fullName,
  completionPercent,
  joinDate,
  completionInformation,
  onClick,
  isActive,
}) {
  return (
    <div
      styleName='team-performance-card'
      onClick={onClick}
      role='button'
      tabIndex={0}
      style={{
        cursor: isActive ? 'pointer' : 'default',
      }}
    >
      <Heading
        as='h2'
        colour='textPrimary'
        size='hamster'
        textTransform='none'
        weight='semiBold'
      >
        {fullName}
      </Heading>
      {joinDate && (
        <Text
          colour='textSecondary'
          inline='false'
          lineHeight='tight'
          size='s'
          textTransform='none'
          weight='regular'
        >
          {isActive ? 'Joined' : 'Invited'} {joinDate}
        </Text>
      )}
      <div styleName='team-performance-card-metrics'>
        <Text lineHeight='tight' size='s' textTransform='none' weight='regular'>
          <TickIcon colour='black' size='tiny' />
          <strong>Completed:</strong> {completionInformation}
        </Text>
        <Text lineHeight='tight' size='s' textTransform='none' weight='regular'>
          <LearningIcon colour='black' size='tiny' />
          <strong>{completionPercent}%</strong> completed
        </Text>
      </div>
      {isActive && (
        <div styleName='team-performance-card-arrow'>
          <ChevronIcon orientation='right' size='small' colour='grey700' />
        </div>
      )}
    </div>
  );
}

TeamPerformanceCard.propTypes = {
  fullName: PropTypes.string.isRequired,
  completionInformation: PropTypes.string.isRequired,
  completionPercent: PropTypes.number,
  joinDate: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  isActive: PropTypes.bool,
};

export default CSSModules(TeamPerformanceCard, styles, {allowMultiple: true});
